import { useEffect, useRef, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { EMBEDDED_LOGIN_ELEMENT_ID, getCatalystAuth, getEmbeddedSignInConfig } from '../lib/catalyst-auth';

export function Login() {
  const { isAuthenticated, isLoading } = useAuth();
  const iframeMounted = useRef(false);
  const [loginError, setLoginError] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated || iframeMounted.current) {
      return;
    }

    try {
      const container = document.getElementById(EMBEDDED_LOGIN_ELEMENT_ID);

      if (!container) {
        return;
      }

      container.innerHTML = '';
      getCatalystAuth().signIn(EMBEDDED_LOGIN_ELEMENT_ID, getEmbeddedSignInConfig());
      iframeMounted.current = true;
    } catch (error) {
      console.error('No se pudo cargar el login embebido de Catalyst:', error);
      setLoginError('No se pudo cargar el formulario de inicio de sesion.');
    }
  }, [isAuthenticated]);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-pink-50 to-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-[#E91E8C] to-[#FF69B4] mb-4 shadow-lg">
            <Sparkles className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl mb-2 text-[#2d2d2d]">Sisters Peluqueros</h1>
          <p className="text-gray-600">Fichas de Tratamientos</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100 min-h-[640px] flex flex-col">
          {isLoading && (
            <div className="mb-4 rounded-lg bg-pink-50 px-4 py-3 text-sm text-[#E91E8C]">
              Comprobando si ya existe una sesion activa...
            </div>
          )}

          {loginError && (
            <div className="mb-4 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600">
              {loginError}
            </div>
          )}

          <div id={EMBEDDED_LOGIN_ELEMENT_ID} className="min-h-[520px] flex-1" />
        </div>

        <p className="text-center text-sm text-gray-500 mt-6">
          Sistema de gestion profesional de tratamientos esteticos
        </p>
      </div>
    </div>
  );
}
